"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserProfile {
    /**
     * @property user_type Type of the authenticated user
     */
    static get user_type() {
        return ToyotaUserProfile.get('userAgent.usertype');
    }
    /**
     * @property app_id Id of the current app
     */
    static get app_id() {
        return ToyotaUserProfile.get('ipapp.info.id');
    }
    /**
     * @property refresh_token generate by OneApp
     */
    static get refresh_token() {
        return ToyotaUserProfile.get('ipapp.info.RefreshToken');
    }
    /**
     * @property access_token generate by OneApp
     */
    static get access_token() {
        return ToyotaUserProfile.get('ipapp.info.AccessToken');
    }
    /**
     * @property navigation_status
     */
    static get navigation_status() {
        return ToyotaUserProfile.get('navi.subscription.status');
    }
    /**
     * @property navigation_expiration
     */
    static get navigation_expiration() {
        return ToyotaUserProfile.get('Navi.Subscription.date');
    }
    /**
     * @property user_token
     */
    static get user_token() {
        return ToyotaUserProfile.get('userAgent.AuthenticationToken');
    }
    /**
     * @property va_status
     */
    static get va_status() {
        return ToyotaUserProfile.get('VirtualAssistant.subscription.stausOnUserProfile');
    }
    /**
     * @property va_expiration
     */
    static get va_expiration() {
        return ToyotaUserProfile.get('VirtualAssistant.subscription.date');
    }
    /**
     * @property properties
     */
    static get properties() {
        return ToyotaUserProfile.getAppProperty(this.app_id);
    }
    /**
     * @method setPropertie Set the value for a requested property
     */
    static setProperty(value, callback) {
        const p = ToyotaUserProfile.setAppProperty(this.app_id, value);
        p.then(() => callback)
            .catch((e) => callback(e));
    }
    /**
     * @method get Set the value for a requested App property
     */
    static getValue(value) {
        return ToyotaUserProfile.get(value);
    }
    /**
     * @method get Set the value for User profile value
     */
    static setValue(path, value, callback) {
        const p = ToyotaUserProfile.set(path, value);
        p.then(() => callback())
            .catch((e) => callback(e));
    }
}
exports.default = UserProfile;
//# sourceMappingURL=UserProfile.js.map